import { type ReactNode, useCallback, useMemo, useState } from 'react';
import { type ActivitiesMetadata, activitiesMetadataService } from '../api';
import ActivitiesMetadataContext from './ActivitiesMetadataContext';

type Props = { children: ReactNode };

const ActivitiesMetadataProvider = ({ children }: Props) => {
  const [metadata, setMetadata] = useState<ActivitiesMetadata>();
  const [isLoading, setIsLoading] = useState(false);

  const load = useCallback(async (options: { signal: AbortSignal }) => {
    if (isLoading)
      return;

    setIsLoading(true);

    try {
      setMetadata(await activitiesMetadataService.get(options));
    } finally {
      setIsLoading(false);
    }
  }, [isLoading]);

  const value = useMemo(() => ({ metadata, load, isLoading }), [metadata, load, isLoading]);

  return (
    <ActivitiesMetadataContext.Provider value={value}>
      {children}
    </ActivitiesMetadataContext.Provider>
  );
};

export default ActivitiesMetadataProvider;
